
$(document).ready(function () {
    let sr = new SourceRecord();
});

export class SourceRecord {

    private initialised: boolean = false;     

    constructor() {
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }            
        this.initialised = true;
    }
}